import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, Target, Upload, TrendingUp } from 'lucide-react';
import { useDemoProfile } from '../../hooks/useDemoProfile';

const DEFAULT_ACTIONS = [
  { label: 'Review queue',            icon: ClipboardCheck, color: '#FF4D94', to: '/drafts',  badge: '3' },
  { label: 'See live waves',          icon: Target,         color: '#00D4FF', to: '/campaigns' },
  { label: 'Add brand data',          icon: Upload,         color: '#A78BFA', to: '/data-room' },
  { label: 'Trending challenges',     icon: TrendingUp,     color: '#FF4D94', to: '/trending' },
];

const COLOR_CYCLE = ['#FF4D94', '#00D4FF', '#FFC83D', '#A78BFA'];
const ICON_CYCLE  = [Target, TrendingUp, ClipboardCheck, Upload];

export default function QuickActionsBar() {
  const { profile, isDemo } = useDemoProfile();
  const actions = (isDemo && profile?.home_quick_actions?.length)
    ? profile.home_quick_actions.map((a, i) => ({
        label: a.label,
        to: a.to,
        icon: ICON_CYCLE[i % ICON_CYCLE.length],
        color: COLOR_CYCLE[i % COLOR_CYCLE.length],
      }))
    : DEFAULT_ACTIONS;
  return (
    <div className="grid grid-cols-4 gap-2" data-testid="quick-actions">
      {actions.map(a => (
        <Link key={a.label} to={a.to}>
          <button className="relative w-full bg-[#242730] border border-[#2E3240] rounded-xl p-4 text-center hover:border-[#00D4FF]/30 hover:bg-[#2a2d36] transition-all group"
                  data-testid={`quick-${a.label.replace(/[\s/]/g, '-').toLowerCase()}`}>
            <a.icon className="h-5 w-5 mx-auto mb-1.5 group-hover:scale-110 transition-transform" style={{ color: a.color }} />
            <p className="text-[10px] font-bold text-gray-300 group-hover:text-white transition-colors">{a.label}</p>
            {a.badge && (
              <span className="absolute top-2 right-2 w-4 h-4 rounded-full bg-[#F59E0B] text-black text-[8px] font-black flex items-center justify-center">
                {a.badge}
              </span>
            )}
          </button>
        </Link>
      ))}
    </div>
  );
}
